import { localisationMaster } from 'Localisation/Localisation'

export const aTimezone = [
  {
    id: -5,
    name: localisationMaster('name-1', 'time-zone'),
    name_tz_main: 'America/Monterrey',
  },
  {
    id: -4,
    name: localisationMaster('name-2', 'time-zone'),
    name_tz_main: 'America/Montreal',
  },
  {
    id: +0,
    name: localisationMaster('name-3', 'time-zone'),
    name_tz_main: 'Etc/Greenwich',
  },
  {
    id: +1,
    name: localisationMaster('name-4', 'time-zone'),
    name_tz_main: 'Europe/Dublin',
  },
  {
    id: +2,
    name: localisationMaster('name-5', 'time-zone'),
    name_tz_main: 'Europe/Amsterdam',
  },
  {
    id: +3,
    name: localisationMaster('name-6', 'time-zone'),
    name_tz_main: 'Europe/Istanbul',
  },
  {
    id: +5,
    name: localisationMaster('name-7', 'time-zone'),
    name_tz_main: 'Asia/Astana',
  },
  {
    id: +6,
    name: localisationMaster('name-8', 'time-zone'),
    name_tz_main: 'Asia/Omsk',
  },
  {
    id: +7,
    name: localisationMaster('name-9', 'time-zone'),
    name_tz_main: 'Asia/Novosibirsk',
  },
  {
    id: +8,
    name: localisationMaster('name-10', 'time-zone'),
    name_tz_main: 'Asia/Shanghai',
  },
  {
    id: +9,
    name: localisationMaster('name-11', 'time-zone'),
    name_tz_main: 'Asia/Seoul',
  },
  {
    id: +10,
    name: localisationMaster('name-12', 'time-zone'),
    name_tz_main: 'Asia/Vladivostok',
  },
  {
    id: +12,
    name: localisationMaster('name-13', 'time-zone'),
    name_tz_main: 'Asia/Kamchatka',
  },
]
